module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "header"
  }, [(!_vm.isLogged) ? _c('router-link', {
    staticClass: "navbar-brand padded",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Item Manager")]) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'loader'
      }
    }
  }, [_c('div', {
    staticClass: "user-picture"
  }, [_c('img', {
    attrs: {
      "src": _vm.profilePicturePath
    }
  })])]) : _vm._e(), _vm._v(" "), _c('account-selector'), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogged),
      expression: "isLogged"
    }],
    staticClass: "ordering padded"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("sort")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordering),
      expression: "ordering"
    }],
    ref: "orderingSelect",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ordering = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.allOrderings), function(ordering) {
    return _c('option', {
      domProps: {
        "value": ordering
      }
    }, [_vm._v(_vm._s(ordering))])
  }))]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "filters padded only-small",
    on: {
      "click": function($event) {
        _vm.toggleFilter()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v(_vm._s(_vm.$route.name === 'filter' ? 'arrow_back' : 'search'))])]) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "padded",
    on: {
      "click": function($event) {
        _vm.handleRefresh()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Reload")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("refresh")])]) : _vm._e(), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogged),
      expression: "!isLogged"
    }],
    staticClass: "login padded",
    on: {
      "click": function($event) {
        _vm.handleLogin()
      }
    }
  }, [_c('span', [_vm._v("Authorize with Bungie.net")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock_open")])]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "padded",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'tools'
        })
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Tools")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("build")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "padded",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'settings'
        })
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("settings")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.user),
      expression: "!user"
    }],
    staticClass: "padded only-big",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'settings'
        })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud_off")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user),
      expression: "user"
    }],
    staticClass: "padded only-big"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogged),
      expression: "isLogged"
    }],
    staticClass: "login padded",
    on: {
      "click": function($event) {
        _vm.handleLogout()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Logout")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("exit_to_app")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46c34a8b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 553
// module chunks = 1